import { Box, Spacer } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/core'
import { useEffect, useState } from 'react'
import { AadharNumberEditText } from '../../comps/AadharNumberEditText'
import { AepsButton } from '../../comps/AepsButton'
import { AepsCheckBox } from '../../comps/AepsCheckBox'
import { Container } from '../../comps/Container'
import { Title } from '../../comps/Title'
import { useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'

export const EnterAadhaarNoScreen = () => {
  const routes: any = useRoute()
  const [aadhaarNo, setAadhaarCardNo] = useState(routes.params?.aadhaarNo)
  const [isValid, setIsValid] = useState(routes.params?.aadhaarNo ? true : false)
  const [isChecked, onCheckBoxClick] = useState(false)
  const mobileNo = routes?.params?.mobileNo
  const [isLoading, setIsLoading] = useState(false)

  const { sendOTPToAadhaar, getConsent } = useStores((root) => ({
    sendOTPToAadhaar: root.customer.sendOTPToAadhaar,
    getConsent: root.consents.getConsent,
  }))

  const navigation = useNavigation()
  //const [sendOTPToAadhaarApi, sendOtpHandler] = useLazyApiData(sendOTPToAadhaar)
  useEffect(() => {
    navigation.setOptions({ headerTitle: 'Link Aadhar' })
  }, [navigation])

  const onSubmit = async () => {
    setIsLoading(true)
    const res = await sendOTPToAadhaar(aadhaarNo, mobileNo)
    setIsLoading(false)
    if (res?.status === 'SUCCESS') {
      navigation.navigate(Screens.ENTER_CUSTOMER_AADHAAR_OTP as never, { aadhaarNo, ...routes?.params } as never)
    }
  }

  const onAadhaarCardTextChange = (aadhaarNo: string, isValid: boolean) => {
    setAadhaarCardNo(aadhaarNo)
    setIsValid(isValid)
  }
  return (
    <Container showFooter={true}>
      <Title title={'Please enter your 12-digit\nAADHAAR Number'} />
      <Spacer size={42} />
      <Box flex={1}>
        <AadharNumberEditText
          initialVal={aadhaarNo ?? ''}
          onTextChanged={onAadhaarCardTextChange}
          label={'Customer aadhar no'}
          type="NORMAL"
        />
        <Spacer size={24} />
        <AepsCheckBox text={getConsent('LINK_AADHAAR')} checked={isChecked} onChange={onCheckBoxClick} />
      </Box>
      <AepsButton
        title={'Generate AADHAAR OTP'}
        onPress={onSubmit}
        disabled={aadhaarNo?.length !== 12 || !isValid || !isChecked}
        isLoading={isLoading}
      />
    </Container>
  )
}
